export default () => {
  return <div>RegisterPendingStep</div>;
};
